import { render, staticRenderFns } from "./govjoke.vue?vue&type=template&id=1ee64554&scoped=true"
import script from "./govjoke.vue?vue&type=script&lang=js"
export * from "./govjoke.vue?vue&type=script&lang=js"
import style0 from "./govjoke.vue?vue&type=style&index=0&id=1ee64554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee64554",
  null
  
)

export default component.exports